import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Bold } from '../../Atoms';
import { getClassMembership } from '../../../Domain/Utils/SelectionUtilies/SelectionUtilies';
import Spinner from '../../Atoms/Spinner/Spinner';
import './MembershipCard.css';
import { ROLE } from '../../../Domain/Settings/Constants/Constants';

const MembershipCard = ({
  handleBuy = () => {},
  parameters = {},
  allWidth = false,
  membership = {},
  isTraining = false,
  schedulerNone = false,
  scrollToCourseCard = () => {}
}) => {
  const validateCourtesy =
    membership?.price?.value > 0
      ? (membership.price.value === null ||
          membership.price.value === 0 ||
          membership.price.value === '') &&
        membership.membership_id !== ROLE.COURTESY
      : null;

  return (
    <div
      className={`card-container mt-5 text-white rounded ${getClassMembership(
        membership?.membership_id
      )}`}>
      <div className="px-0 justify-content-center mt-5 position-relative">
        <img
          className={'logo-membership-portal'}
          src={membership?.image_membership}
          alt={membership?.name}
        />
        <div style={{ height: '27.2rem' }} className="lt-card-title px-4 mt-2">
          <Bold className={'mb-3 text-center lt-card-title '}>{membership?.name}</Bold>
          <div
            className="container-service-membership text-center"
            style={{ maxHeight: '3rem', overflowY: 'auto', fontSize: '15px' }}>
            <span> {membership?.description || <Spinner backgroundColor="white" />}</span>
          </div>
          {/* {membership?.price?.percentage > 0 && (
            // <BorderT1
            //   className={`${getBgDiscountMembership(
            //     membership?.membership_id
            //   )} text-center w-100 mb-1 p-2 rounded border-white object-fit-contain my-3 pt-2`}>
            //   {isNaN(membership?.price?.percentage) && membership?.price?.percentage < 0 ? (
            //     <Bold size="16px">{parameters?.BIG_DIS_LABEL?.value}</Bold>
            //   ) : (
            //     <Bold className={'p-0 m-0'} size="18px">
            //       {Math.round(membership?.price?.percentage * 100)}%{' '}
            //       {parameters?.DIS_SCHE_LABEL?.value || '...'}
            //     </Bold>
            //   )}
            // </BorderT1>
            <></>
          )} */}

          {membership?.price?.value > 0 && membership?.membership_id !== ROLE.COURTESY ? (
            <div
              className={`d-flex flex-column mt-2  ${
                allWidth
                  ? 'col-4 col-xl-5 justify-content-center align-items-end'
                  : 'align-items-center'
              }`}
              style={{ paddingBottom: '8px' }}>
              <Bold size="28px">
                {!isNaN(membership?.price?.value)
                  ? Math.floor(
                      membership?.price?.value -
                        membership?.price?.value * membership?.price?.percentage
                    ) +
                    ' ' +
                    membership?.price?.main_currency
                  : 'Proximamente'}
              </Bold>
              {membership?.price?.percentage > 0 && (
                <div className="d-flex " style={{ marginTop: '-8px' }}>
                  <Bold className="me-2" style={{ color: 'white' }} size="18px">
                    {parameters?.BEFORE_MEMBERSHIP?.value}
                  </Bold>

                  <Bold style={{ color: 'white', textDecoration: 'line-through' }} size="18px">
                    {membership?.price?.value + ' ' + membership?.price?.main_currency}
                  </Bold>
                </div>
              )}
              {allWidth && <BuyButton />}
            </div>
          ) : isTraining || !membership?.price ? null : (
            <Bold size="28px">
              <div className="py-3 text-center">
                {parameters?.INF_MSG_47?.description_value || <Spinner backgroundColor="white" />}
              </div>
            </Bold>
          )}
          <div
            style={{ height: isTraining || !membership?.price?.value ? '22rem' : '18rem' }}
            className={`container-service-membership text-start mt-1 ${
              isTraining && schedulerNone ? 'h-75' : ''
            }`}>
            <ul className="container-list-services px-0">
              {membership.service?.map((service, index) => (
                <li key={index} className="d-flex align-items-center mt-3">
                  <div className="d-flex align-items-center">
                    <FontAwesomeIcon
                      fontSize="12px"
                      color="var(--corporative-yellow)"
                      icon={faCircleCheck}
                    />
                  </div>
                  <span className="mx-2" style={{ marginTop: '-3px', fontSize: '14px' }}>
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="text-center" style={{ position: 'relative', top: '5%' }}>
          {isTraining && schedulerNone ? (
            <button
              type="button"
              aria-label="redirect button"
              onClick={() => scrollToCourseCard()}
              style={{
                borderRadius: '5px',
                background: 'var(--corporative-yellow)',
                opacity: '1',
                color: 'black'
              }}
              className={`btn btn-radius lt-btns m-0 ${allWidth ? '' : 'w-75'}`}>
              {parameters?.REGISTER_AT?.value}
            </button>
          ) : (
            <button
              aria-label="Submit button"
              onClick={() =>
                isTraining
                  ? scrollToCourseCard()
                  : schedulerNone
                  ? scrollToCourseCard()
                  : handleBuy(membership)
              }
              style={{
                borderRadius: '5px',
                background:
                  (membership?.price?.value === null ||
                    membership?.price?.value === 0 ||
                    membership?.price?.value === '') &&
                  membership?.membership_id !== ROLE.COURTESY
                    ? isTraining
                      ? 'var(--corporative-yellow)'
                      : !!!membership?.price?.value && membership?.membership_id !== ROLE.COURTESY
                      ? 'rgba(168, 162, 6, 0.967)'
                      : schedulerNone
                      ? 'rgba(168, 162, 6, 0.967)'
                      : 'var(--corporative-yellow)'
                    : !!!membership?.price?.value && membership?.membership_id !== ROLE.COURTESY
                    ? isTraining
                      ? 'var(--corporative-yellow)'
                      : 'rgba(145, 140, 7, 0.97)'
                    : schedulerNone
                    ? 'rgba(168, 162, 6, 0.967)'
                    : 'var(--corporative-yellow)',
                opacity: '1',
                color: 'black'
              }}
              className={`btn btn-radius m-0 ${allWidth ? '' : 'w-75'}`}
              disabled={
                isTraining
                  ? false
                  : schedulerNone ||
                    (!!!membership?.price?.value && membership?.membership_id !== ROLE.COURTESY)
                  ? true
                  : validateCourtesy
              }>
              {parameters?.REGISTER_AT?.value}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MembershipCard;
